import Tooltip, { type TooltipProps } from './Tooltip';
import { FieldLabel } from '~/components/ui/field';
import { cn } from '~/lib/utils';

type InputLabelProps = {
  label: React.ReactNode;
  tooltip?: React.ReactNode;
  children?: React.ReactNode;
  tooltipProps?: Partial<TooltipProps>;
  className?: string;
  htmlFor?: string;
};

export default function InputLabel({
  label,
  tooltip,
  children,
  tooltipProps,
  className,
  htmlFor,
}: InputLabelProps) {
  return (
    <FieldLabel htmlFor={htmlFor} className={cn('flex min-h-5 items-center', className)}>
      <Tooltip content={tooltip} {...tooltipProps}>
        <span className="text-foreground text-[13px] font-medium tracking-tight">{label}</span>
      </Tooltip>
      {children}
    </FieldLabel>
  );
}
